module.exports = __webpack_public_path__ + "img/account-detail-icon.d4bd622d.svg";